<template>
    <div>
        <input :type="type" :name="name" :placeholder="placeholder" :required="required" :min="min" :max="max"
            :value="modelValue" :autocomplete="name + '-new'" @input="$emit('update:modelValue', $event.target.value)"
            class="form-control" v-bind="$attrs" />
        <div class="form-text">{{ help }}</div>
    </div>
</template>

<script>
export default {
    name: 'TextInput',

    // Esto evita que Vue intente pasar atributos como `id`, `value`, etc. al nodo raíz automáticamente
    inheritAttrs: false,

    props: {
        name: String,
        type: String,
        placeholder: String,
        required: {
            type: Boolean,
            default: false,
        },
        min: String,
        max: String,
        modelValue: [String, Number],
        help: String,
    },
}
</script>

<style scoped>
/* Aquí puedes añadir estilos si necesitas */
div {
    width: 100%;
}
</style>


<!-- <template>


    <input :type="type" :name="name" :placeholder="placeholder" :required="false" :min="min" :max="max"
        :value="modelValue" :autocomplete="name + '-new'" @input="$emit('update:modelValue', $event.target.value)"
        class="form-control">
    <div class="form-text">{{ help }}</div>

</template>

<script>
export default {
    name: 'Text-Input',
    props: {
        name: String,
        type: String,
        placeholder: String,
        required: {
            type: Boolean,
            default: false,
        },
        min: String,
        max: String,
        modelValue: String,
        help: String,
    },
}
</script>

<style></style> -->